"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.id = void 0;
/** https://docs.tsafe.dev/id  */
var id = function (x) { return x; };
exports.id = id;
//# sourceMappingURL=id.js.map